import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../env";

export const fetchFacilities = createAsyncThunk(
  "facilityDetails/fetchFacilities",
  async (hotelId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}api/dashboard/admin/facility/${hotelId}`);     
        return response.data.data;  
      } catch (error) {
        throw new Error(error.response?.data?.message || error.message);  
      }
   
  }
);

export const saveTagFacilities = createAsyncThunk(
    "facilityDetails/saveTagFacilities",
    async ({ hotelId, selectedFacilities, createdBy }) => {
      const response = await axios.post(`${REACT_APP_API_URL}api/dashboard/admin/facilityTag`, {
        hotelId,
        selectedFacilities,
        createdBy,
      });
      return response.data;
    }
  );

const facilityDetailSlice = createSlice({
  name: "facilityDetails",
  initialState: {
    facilityData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFacilities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFacilities.fulfilled, (state, action) => {
        state.loading = false;
        state.facilityData = action.payload;
      })
      .addCase(fetchFacilities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(saveTagFacilities.fulfilled, (state, action) => {
        console.log(action.payload); 
      });
  },
});

export default facilityDetailSlice.reducer;
